<div class="rating">
  <h5 class="fw-bold">Quanto è stato facile usare questo servizio?</h5>
  <span *ngFor="let star of this.ratingService.starsArray; let i = index" class="user-select-none"
        [class.active]="i < this.ratingService.selectedRating"
        (click)="selectRating(i + 1)">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
      <path [attr.fill]="i < this.ratingService.selectedRating ? 'gold' : 'lightgrey'" stroke="black" stroke-width="1.1"
            d="M12 1.3l2.8 8.8h8.1l-6.6 4.8 2.8 8.7-6.9-5.3-6.9 5.3 2.8-8.7-6.6-4.8h8.1z"/>
    </svg>
  </span>
</div>
